/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Notifications_More_UnreadInputs */

const en_notifications_more_unread = /** @type {(inputs: Notifications_More_UnreadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} more unread`)
};

const pl_notifications_more_unread = /** @type {(inputs: Notifications_More_UnreadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} więcej nieprzeczytanych`)
};

/**
* | output |
* | --- |
* | "+{count} more unread" |
*
* @param {Notifications_More_UnreadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const notifications_more_unread = /** @type {((inputs: Notifications_More_UnreadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_More_UnreadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_notifications_more_unread(inputs)
	return en_notifications_more_unread(inputs)
});